import {Action} from '@ngrx/store';

export enum FloatingNodesActionTypes {
  FLOATED_NODES_ADDED = '[Floating Nodes] floated nodes added',
  FLOATED_NODES_REMOVED = '[Floating Nodes] floated nodes removed',
  FLOATED_NODES_INIT = '[Floating Nodes] init',
}

export class FloatedNodesAdded implements Action {
  readonly type = FloatingNodesActionTypes.FLOATED_NODES_ADDED;

  constructor(public payload: { nodes: Array<string>, layer: string }) {
  }
}

export class FloatedNodesRemoved implements Action {
  readonly type = FloatingNodesActionTypes.FLOATED_NODES_REMOVED;

  constructor(public payload: { nodes: Array<string>, layer: string }) {
  }
}

export class FloatedNodesInit implements Action {
  readonly type = FloatingNodesActionTypes.FLOATED_NODES_INIT;
  constructor(public payload: any) {
  }
}

export type FloatedNodesAction = FloatedNodesAdded | FloatedNodesRemoved | FloatedNodesInit;
